// extracted by mini-css-extract-plugin
module.exports = {"container":"cv","input":"cw","indicator":"cx","checked":"cy","label":"cz","disabled":"cA"};